import React, {useState} from 'react';
import './TopHeader.scss';
import {Box, Typography} from '@mui/material';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {t} from 'i18next';
import ArrButton from '../../../common/arr-button/ArrButton';
import {ReactComponent as InfoIcon} from '../../../../assets/images/info-icon.svg';

import BulkUserMainView from '../../bulk-access/BulkUserMainView';
import AssignUsers from '../../assign-users/AssignUsers';
import {AddUser} from '../../add-user/AddUser';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import {setHandleDrawerOpen} from '../../../../redux/slice/bulkUsersSlice';
import UsersNotYetLoggedIn from '../../not-logged-in-users/UsersNotYetLoggedIn';

type TopHeaderProps = {
  onUserAdded?: () => void;
};

const TopHeader: React.FC<TopHeaderProps> = ({onUserAdded}) => {
  const [isAddUser, setIsAddUser] = useState<boolean>(false);
  const [isUserNotLoggedInYet, setIsUserNotLoggedInYet] =
    useState<boolean>(false);
  const roleId = useSelector(
    (state: RootState) => state.authenticatedUser.user?.roleId
  );

  const handleDrawerOpen = useSelector(
    (state: RootState) => state.bulkUser.handleDrawerOpen
  );
  const dispatch = useDispatch();
  const bulkAccesshandler = () => {
    dispatch(setHandleDrawerOpen(true));
  };

  const [isAssignUser, setIsAssignUser] = useState<boolean>(false);

  const handleClose = () => {
    setIsAssignUser(false);
  };
  return (
    <Box className="view-user-header">
      <Box className="view-user-title">
        <Typography
          className="typo-text headline3_size view-user-title-text"
          data-testid={`top-header-title`}
        >
          {t('userManagement.manageUsers.title')}
        </Typography>
        <ArrTooltipWrapper
          title={t('userManagement.manageUsers.title')}
          trigger={
            <InfoIcon
              fontSize="medium"
              className="view-user-info-icon"
              data-testid="view-user-info-icon"
            />
          }
        >
          {t('userManagement.manageUsers.manageUsersShortInfo')}
        </ArrTooltipWrapper>
      </Box>
      <Box gap={1} className="view-user-button-section">
        <ArrButton
          aria-label={t('userManagement.addUser.notYetLoggedIn')}
          variant="secondary"
          size="medium"
          dataTestId="not-yet-logged-in-btn"
          onClick={() => {
            setIsUserNotLoggedInYet(true);
          }}
        >
          {t('userManagement.manageUsers.notYetLoggedIn')}
        </ArrButton>
        <ArrButton
          aria-label={t('userManagement.addUser.title')}
          variant="secondary"
          size="medium"
          dataTestId="add-user-btn"
          onClick={() => {
            setIsAddUser(true);
          }}
        >
          {t('userManagement.addUser.title')}
        </ArrButton>
        {roleId !== 1 && roleId !== 2 && (
          <ArrButton
            aria-label={t('userManagement.manageUsers.assign')}
            variant="secondary"
            size="medium"
            dataTestId="assign-user-btn"
            onClick={() => {
              setIsAssignUser(true);
            }}
            id="assign-user-btn"
            name="assign-user-btn"
          >
            {t('userManagement.manageUsers.assign')}
          </ArrButton>
        )}
        {roleId !== 2 && (
          <ArrButton
            name={t('userManagement.manageUsers.bulkAccess')}
            id={t('userManagement.manageUsers.bulkAccess')}
            aria-label={t('userManagement.manageUsers.bulkAccess')}
            variant="secondary"
            size="medium"
            dataTestId="bulk-access-btn"
            onClick={bulkAccesshandler}
          >
            {t('userManagement.manageUsers.bulkAccess')}
          </ArrButton>
        )}
      </Box>
      {handleDrawerOpen && (
        <BulkUserMainView onUsersBulkUpdated={onUserAdded} />
      )}
      {isAssignUser && (
        <AssignUsers
          open={isAssignUser}
          handleDrawer={handleClose}
          onUsersAssigned={onUserAdded}
        />
      )}
      {isAddUser && (
        <AddUser
          showDrawer={isAddUser}
          handleDrawer={setIsAddUser}
          onUserAdded={onUserAdded}
        />
      )}
      {isUserNotLoggedInYet && (
        <UsersNotYetLoggedIn
          showPanel={isUserNotLoggedInYet}
          setShowPanel={setIsUserNotLoggedInYet}
        />
      )}
    </Box>
  );
};

export default TopHeader;
